import { string } from "prop-types";

import styled from "styled-components/macro";

import ChipGlyph from "./ChipGlyph";
import ChipLabel from "./ChipLabel";
import { chipBox, chipChrome } from "./chipPillStyle";

// Static (non-interactive) verification chip. Shares the badge family's
// light-blue chrome (fnBlue100 background, fnBlue200 border, fnBlue glyph) and
// label typography (ChipLabel). Mirrors the interactive admin slide
// (VerificationBadge's SlideContent): a tight ChipGlyph capped via `iconFontSize`
// so the static and interactive admin chips can't drift.
const StaticPill = ({ icon, iconFontSize, label, ariaLabel }) => (
  <PillStatic aria-label={ariaLabel}>
    <PillRow>
      {icon && <ChipGlyph icon={icon} fontSize={iconFontSize} />}
      <ChipLabel noGap>{label}</ChipLabel>
    </PillRow>
  </PillStatic>
);
StaticPill.propTypes = {
  icon: string,
  iconFontSize: string,
  label: string,
  ariaLabel: string,
};

export default StaticPill;

// Chrome + box from the shared chip fragments (single source of truth for the
// family's dimensions). The label typography lives in ChipLabel.
const PillStatic = styled.span`
  ${chipChrome}
  ${chipBox}
`;

// Matches SlideContent's SlideRow: no left inset of its own (chipBox owns the
// box insets) and a 2px icon→label gap.
const PillRow = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 2px;
`;
